
import { useState, useEffect } from 'react';
import actionTypes from '../../../actions/ActionTypes';
import AutoComplete from '../../../components/AutoComplete';
import { LoadReaders } from '../../../actions/ReadersActions';
import { LoadDefaultsByBP } from '../../../actions/DefaultActions';
import { GetTemplatesByBP } from '../../../actions/TemplateActions';
import ReadersStore from '../../../stores/ReadersStore';
import DefaultsStore from '../../../stores/DefaultsStore';
import TemplateStore from '../../../stores/TemplateStore';
import { GetStepCount2, BulkActionChangeReader } from '../../../actions/BulkActions';

function TemplateChangeDlg(props) {
    const [allReaders, setAllReaders] = useState([]);
    const [allDefaults, setAllDefaults] = useState([]);
    const [allTemplates, setAllTemplates] = useState([]);
    const [readerId, setReaderId] = useState(0);
    const [defaultId, setDefaultId] = useState(0);
    const [templateId, setTemplateId] = useState(0);
    const [display, setDisplay] = useState('options');
    const [docCount, setDocCount] = useState(0);
    const [readerName, setReaderName] = useState('');
    const [defaultName, setDefaultName] = useState('');
    const [templateName, setTemplateName] = useState('');
    const [actionDesc, setActionDesc] = useState('');
    const [changeCode, setChangeCode] = useState(0);
    const [updateResults, setUpdateResults] = useState([]);
    const [errorMessage, setErrorMessage] = useState([]);

    const onReaderChange = () => {
        let lastAction = ReadersStore.getLastAction();
        if(lastAction === actionTypes.GetReaders)
        {
            let readers = ReadersStore.getReaders();
            let allReaders = [
                ...readers,
                {readerId: -1, name: 'No Change'},
                {readerId: 0, name: 'No Reader'}
            ];
            setAllReaders(allReaders);
            setReaderId(-1);
        }
    }

    const onDefaultChange = () => {
        let lastAction = DefaultsStore.getLastAction();
        console.log(lastAction);
        if(lastAction === actionTypes.GetDefaultsByBP)
        {
            let defaults = DefaultsStore.getDefaultsByBP();
            console.log(defaults);
            defaults.push({id: -1, name: 'No Change'});
            defaults.push({id: 0, name: 'No Default'});
            setAllDefaults(defaults);
            setDefaultId(-1);
        }
    }

    const onTemplateChange = () => {
        let lastAction = TemplateStore.getLastChange();
        if(lastAction === actionTypes.TemplateByBP)
        {
            let templates = TemplateStore.getTemplatesByBP();
            templates.push({templateId: -1, name: 'No Change'});
            templates.push({templateId: 0, name: 'No Template'});
            setAllTemplates(templates);
            setTemplateId(-1);
        }
    }

    useEffect(() => {
        console.log('load templateDlg')

        //let step = searchParams.get('Step');
        let params = new URLSearchParams(window.location.search);
        var bpParam = params.get('BP');
        LoadReaders();
        LoadDefaultsByBP(bpParam);
        GetTemplatesByBP(bpParam);
        ReadersStore.addChangeListener(onReaderChange);
        DefaultsStore.addChangeListener(onDefaultChange);
        TemplateStore.addChangeListener(onTemplateChange);
        return () => {
            ReadersStore.removeChangeListener(onReaderChange);
            DefaultsStore.removeChangeListener(onDefaultChange);
            TemplateStore.removeChangeListener(onTemplateChange);
        };
    }, []);

    const readerSuggestionClick = (e) => {
        setReaderId(e);
    }

    const stepCountCallback = (count) => {
        console.log(count);
        setDocCount(count);
    }

    const onClickTemplateChange = (changeType) => {
        let docs = props.docs();
        console.log(docs);
        if(docs.fullStep) {
            // lookup doc count in step
            let search = props.getSearch();
            console.log(search);
            GetStepCount2(search, stepCountCallback);
        } else {
            setDocCount(docs.docIds.length);
        }
        let readerSelect = allReaders.find(r => r.readerId === readerId);
        if(readerSelect) setReaderName(readerSelect.name);
        let defaultSelect = allDefaults.find(d => d.id === defaultId);
        if(defaultSelect) setDefaultName(defaultSelect.name);
        let templateSelect = allTemplates.find(t => t.templateId === templateId);
        if(templateSelect) setTemplateName(templateSelect.name);
        setChangeCode(changeType);
        if(changeType === 1) setActionDesc('Save changes only');
        if(changeType === 2) setActionDesc('Save and apply changes');
        if(changeType === 3) setActionDesc('Save changes, clear fields, and set to beginning');
        setDisplay('confirm');

    }

    const defaultSuggestionClick = (e) => {
        setDefaultId(e);
    }

    const templateSuggestionClick = (e) => {
        setTemplateId(e);
    }

    const applyChangeClick = () => {
        setDisplay('final');
        let docs = props.docs();
        console.log(docs);
        let search = props.getSearch();
        BulkActionChangeReader(search, docs, readerId, defaultId, templateId, changeCode, applyChangeCallback);
        setDisplay('processing');
    }

    const applyChangeCallback = (data) => {
        console.log(data);
        if (data.status.toLowerCase() === 'failure'){
            setErrorMessage(data.message);
            setDisplay('error');
        }
        else{
            setUpdateResults(data.responseDocuments);
            setDisplay('done');
        }
    }

    return (
        <div className='td-dialogue-container'>
        <div className='td-dialogue card' style={{ width: '700px', height: '500px' }}>
          <div className='card-header'>
            Change Readers:
            <button
              type='button'
              className='btn-close'
              onClick={() => props.close()}
            />
          </div>
          <div
            className='card-body'
            style={{ height: '350px', overflow: 'auto' }}
          >
            {display === 'options' && <div>
                <label className='form-label'>AI OCR Reader</label>
                <AutoComplete
                id={`ChReaderList`}
                allowedValues={allReaders}
                value={readerId}
                valueField='readerId'
                displayField='name'
                onChange={readerSuggestionClick}
                //setFocus={this.setCurrentRoute}
                />
                <label className='form-label'>Default</label>
                <AutoComplete
                id={`ChDefaultList`}
                allowedValues={allDefaults}
                value={defaultId}
                valueField='id'
                displayField='name'
                onChange={defaultSuggestionClick}
                //setFocus={this.setCurrentRoute}
                />
                <label className='form-label'>Template</label>
                <AutoComplete
                id={`ChTemplateList`}
                allowedValues={allTemplates}
                value={templateId}
                valueField='templateId'
                displayField='name'
                onChange={templateSuggestionClick}
                />
                <div className='d-grid gap-2 mt-3'>
                    <button onClick={() => onClickTemplateChange(1)} type='button' className='btn btn-secondary'>Save above changes</button>
                    <button onClick={() => onClickTemplateChange(2)} type='button' className='btn btn-success'>Save and apply changes</button>
                    <button onClick={() => onClickTemplateChange(3)} type='button' className='btn btn-primary'>Save, clear out fields, and send to start of workflow</button>
                </div>
            </div> }
            {display === 'confirm' &&
                <div style={{width: '660px', textAlign: 'center'}}>
                    <div style={{fontSize: '16pt'}}><strong>Confirm changes:</strong></div>
                    <div className='pt-3' style={{fontSize: '14pt', }}>
                        <div>AI OCR Reader: {readerName}</div>
                        <div>Default: {defaultName}</div>
                        <div>Template: {templateName}</div>
                    </div>
                    <div className='pt-4' style={{fontSize: '16pt'}}> Documents Affected: {docCount} </div>
                    <div className='pt-3'>{actionDesc}</div>
                    <div>
                    <button className='btn btn-success btn-lg mt-4' onClick={() => applyChangeClick()}>Confirm</button>
                    </div>
                    <div>
                    <button className='btn btn-secondary btn-lg mt-2' onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            }
            {display === 'processing' &&
                <div style={{width: '660px', textAlign: 'center'}}>
                    <div style={{fontSize: '16pt'}} className='mt-4'>Processing</div>
                    <div className='mt-4' style={{color: '#56b21e'}}>
                    <i className='fa-solid fa-spinner fa-spin fa-6x'></i>
                    </div>
                    <button className='btn btn-secondary btn-lg mt-4' onClick={() => props.close('done')}>Close</button>

                </div>
            }
            {display === 'done' &&
                <div>
                    <div style={{fontSize: '12pt'}} className='mt-4'>{`${updateResults.length} document${updateResults.length > 1 ? 's' : ''} updated.`}</div>
                    <div style={{height: '300px', overflow: 'auto'}}>
                        <ul>
                            {updateResults.map((doc) => (
                                <li key={doc.documentId} >Document {doc.documentId}: {doc.message}</li>
                            ))}
                        </ul>
                    </div>
                    <button className='btn btn-secondary mt-1' onClick={() => props.close('done')}>Close</button>

                </div>
            }

            {display === 'error' &&
                <div style={{width: '660px', textAlign: 'center'}}>
                    <div style={{fontSize: '16pt'}} className='mt-4'>Error</div>
                    <div className='pt-4' style={{fontSize: '12pt'}}>'{errorMessage}'. Check system logs for more details</div>
                    <button className='btn btn-secondary btn-lg mt-4' onClick={() => props.close('done')}>Close</button>
                </div>
            }
          </div>
        </div>
      </div>
    )

}

export default TemplateChangeDlg;